import { useQuery } from '@tanstack/react-query';
import { API_QUERY_KEYS } from 'consts';
import { getDocumentPages } from '../requests';
import type { GetDocumentPagesRequestType } from '../types';

export const useGetDocumentPages = (
  documentId?: GetDocumentPagesRequestType['documentId'],
) =>
  useQuery({
    queryKey: [API_QUERY_KEYS.documentPages, { documentId }],
    queryFn: () => getDocumentPages({ documentId: documentId! }),
    enabled: !!documentId,
  });
